import React, { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  Check,
  Plus,
  RotateCcw,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import "../../style/css/sales-invoice-terminal.css";
import {
  useTerminalChrome,
  TermCmdBar,
  TermColumns,
  TermStatusBar,
} from "../transactions/terminal/TerminalChrome";
import toast from "react-hot-toast";
// import { ProductClass } from "../../../core/json/Product";
// import { getUnitList } from "../../../services/MasterApiServices";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
// import {
//   getStockByBranch,
//   addEditStock,
// } from "../../../services/StockApiServices";
// import { InvStockAdjustment } from "../../../core/json/invStockAdjust";
// import { InvStockAdjustmentDetail } from "../../../core/json/invStockAdjustDetail";
import { useSelector, useDispatch } from "react-redux";
import {
  getOpeningBalance,
  saveOpeningBalance,
  deleteOpeningBalance,
} from "../../services/AccountApiServices";
import { getAccountledger } from "../../services/AccountApiServices";
import { fetchBranchSettings } from "../../redux/settingbyBranch";
import { OpeningStockMaster } from "../../core/json/OpeningStockMaster";
import { FinancialYear } from "../../core/json/FinancialYear";
import { Company } from "../../core/json/Company";
import { LedgerBranchOpeningDetail } from "../../core/json/OpeningDetail";
import { LedgerBranchOpeningMaster } from "../../core/json/OpeningMaster";
import { LedgerClass } from "../../core/json/Ledger";


const OpeningBalanceModal = ({ mode, data, handleClose, handleRefresh }) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    reset,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      invdate: dayjs().format("YYYY-MM-DD"),
    },
    mode: "onBlur",
  });
  const { formatedLedger } = useSelector((state) => state.ledger);
  const [loading, setloading] = useState(false);
  const [unitData, setunitData] = useState([]);
  const [products, setProducts] = useState([]);
  const [ledgerData, setLedgerData] = useState();
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const dispatch = useDispatch();
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const [selectedType, setSelectedType] = useState(0);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
    const { branchsettings } = useSelector((state) => state.settings);


  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const handleno = async () => {
    try {
      const response = await getOpeningBalance(branch);
      const receiptData = response;
      // Find the maximum number from the existing entries
      const maxEntryNumber =
        receiptData?.length > 0
          ? receiptData
              ?.map((data) => parseInt(data.no))
              ?.reduce((max, num) => Math.max(max, num), 0) // Find the maximum number
          : 0;
      let counter = maxEntryNumber + 1;
      setValue(`no`, counter);
      counter++;
    } catch (error) {
      console.error("Failed to fetch payments data", error);
    }
  };
  useEffect(() => {
    resetmodal();
  }, [data, setValue]);
  useEffect(() => {
    if (mode === "add") {
      handleno();
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }
    }
    handleLedgerList();
    // handleCurrencyList();

    dispatch(fetchBranchSettings(branch.guid));
  }, []);

  const handleAddRow = () => {
    append({
      batch: "0",
      baseQuantity: 0,
      adjQuantity: 0,
      unit: "",
      product: null,
    });
  };

  function resetmodal() {
    if (mode === "edit" && data) {
      const resetData = {
        no: data.no,
        remark: data.remarks,
        // the date picker is bound to "invdate"
        invdate: data.date ? dayjs(data.date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
        // the API returns the lines as ledgerBranchOpeningDetails (same key the list reads)
        items: (
          data?.ledgerBranchOpeningDetails ||
          data?.LedgerBranchOpeningDetails ||
          []
        ).map((detail) => ({
          ledger: detail?.ledger?.guid,
          credit: detail.credit,
          debit: detail.debit,
          refNo: detail.refNo,
          remarks: detail.remarks,
        })),
      };

      reset(resetData);
    }
  }

  const handleLedgerList = async () => {
    try {
      const response = await getAccountledger();
      if (Array.isArray(response)) {
        setLedgerData(
          response?.map((e) => ({
            value: e.guid,
            label: e.name,
          }))
        );
      } else {
        setLedgerData([]);
      }
    } catch (error) {
      setLedgerData([]);
    }
  };
  const handleFormSubmit = async (formdata) => {
    setloading(true);
    const objOpeningBal = new LedgerBranchOpeningMaster();
    const objfinance = new FinancialYear();
    // local calendar date of the picked day - never a UTC timestamp (AC-16)
    objOpeningBal.date = formdata.invdate
      ? dayjs(formdata.invdate).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
    objOpeningBal.no = formdata.no;
    objOpeningBal.id = mode == "edit" ? data.id : 0;
    objOpeningBal.guid = mode == "edit" ? data.guid : "";
    objOpeningBal.remarks = formdata.remark;
    objOpeningBal.branch = branch;
    objOpeningBal.financialYear = objfinance;
    objfinance.id = branchsettings?.defaultFinancialYearID;
    objOpeningBal.company = companyInfolist[0];
    objOpeningBal.createdUser = userId.id;
    objOpeningBal.updatedUser = userId.id;

    for (const row of formdata.items) {
      const objdetail = new LedgerBranchOpeningDetail();
      const objLedger = new LedgerClass();
      objLedger.guid = row.ledger;
      objdetail.ledger = objLedger;
      objdetail.credit = Number(row.credit);
      objdetail.debit = Number(row.debit);
      objdetail.refNo = row.refNo;
      objdetail.remarks = row.remarks;

      objOpeningBal.ledgerBranchOpeningDetails.push(objdetail);
    }

    try {
      const response = await saveOpeningBalance(objOpeningBal);
      if (response?.data === true) {
        toast.success("Success");
        handleRefresh();
        handleClose();
      } else {
        toast.error(response?.data?.Message || "Opening balance was not saved");
      }
      setloading(false);
    } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error(
        "Error handling opening balance:",
        error?.response?.data?.Message
      );
      setloading(false);
    }
  };

  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one row entry is required");
    }
  }
  // react-select menus render into this node inside .si-term, so they pick
  // up the terminal's colour tokens like everything else
  const [menuHost, setMenuHost] = useState(null);
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };

  // view preferences only - theme, full screen
  const chrome = useTerminalChrome("openingbalance");
  const docDate = watch("invdate");
  const remarkShown = watch("remark");
  // display only - read from the lines, the form keeps no totals of its own
  const watchedItems = watch("items") || [];
  const debitSum = watchedItems.reduce(
    (a, row) => a + (parseFloat(row?.debit) || 0),
    0
  );
  const creditSum = watchedItems.reduce(
    (a, row) => a + (parseFloat(row?.credit) || 0),
    0
  );
  const netSum = debitSum - creditSum;

  return (
    <div
      className="modal fade show si-term si-term--txn"
      data-si-theme={chrome.theme}
      style={{ display: "block" }}
      tabIndex="-1"
    >
      <div className="modal-dialog si-dialog">
        <div className="modal-content si-content">
          <form className="si-form" onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="si-grid">
              <div className="si-left">
                {/* ============ COMMAND BAR ============ */}
                <TermCmdBar
                  chrome={chrome}
                  title="Opening Balance"
                  docNo={watch("no")}
                  state={
                    mode === "edit"
                      ? { key: "edit", label: "Editing" }
                      : { key: "new", label: "New" }
                  }
                  onBack={handleClose}
                />
                {/* entry no. is generated - the header shows it */}
                <input
                  type="text"
                  className="si-offscreen"
                  tabIndex={-1}
                  aria-hidden="true"
                  {...register("no")}
                  required
                  disabled
                />

                {/* ============ HEADER FIELDS ============ */}
                <section className="si-strip">
                  <div className="si-strip-row si-strip-row--auto">
                    <div className="si-fld">
                      <label>
                        Date <span className="si-req">*</span>
                      </label>
                      <Controller
                        control={control}
                        name="invdate"
                        render={({ field: { onChange, value } }) => (
                          <DatePicker
                            className="si-date"
                            value={value ? dayjs(value) : dayjs()}
                            format="DD-MM-YYYY"
                            onChange={(date) =>
                              onChange(date ? date.format("YYYY-MM-DD") : null)
                            } // Update on change
                          />
                        )}
                      />
                    </div>
                    <div className="si-fld si-fld--wide">
                      <label>Remark</label>
                      <input
                        type="text"
                        className="si-in"
                        placeholder="Note for this opening balance"
                        {...register(`remark`)}
                      />
                    </div>
                  </div>
                </section>

                {/* ============ LINES ============ */}
                <section className="si-lines">
                  <TermColumns chrome={chrome} columns={[]}>
                    <button
                      type="button"
                      className="si-iconbtn"
                      onClick={handleAddRow}
                    >
                      <Plus />
                      <span>Add line</span>
                    </button>
                  </TermColumns>

                  <div className="si-tablewrap">
                    <table className="si-table" style={{ minWidth: "820px" }}>
                      <thead>
                        <tr>
                          <th style={{ width: "260px" }}>
                            Ledger <span className="si-req">*</span>
                          </th>
                          <th className="n" style={{ width: "120px" }}>
                            Debit <span className="si-req">*</span>
                          </th>
                          <th className="n" style={{ width: "120px" }}>
                            Credit <span className="si-req">*</span>
                          </th>
                          <th style={{ width: "130px" }}>
                            Ref No. <span className="si-req">*</span>
                          </th>
                          <th>Remarks</th>
                          <th style={{ width: "44px" }} aria-label="Line actions" />
                        </tr>
                      </thead>
                      <tbody>
                        {fields?.map((obj, index) => {
                          return (
                            <tr className="si-line" key={index}>
                              <td data-label="Ledger">
                                <Controller
                                  control={control}
                                  name={`items[${index}].ledger`}
                                  render={({ field: { onChange, value } }) => (
                                    <Select
                                      classNamePrefix="react-select"
                                      className="si-itemsel"
                                      placeholder="Ledger"
                                      options={formatedLedger}
                                      value={formatedLedger?.find(
                                        (option) => option.value === value
                                      )}
                                      onChange={(selectedOption) => {
                                        onChange(selectedOption.value);
                                      }}
                                      menuPortalTarget={menuHost}
                                      menuPosition="fixed"
                                      styles={siSelectStyles}
                                      required
                                    />
                                  )}
                                />
                              </td>
                              <td className="n" data-label="Debit">
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  className="si-cellin"
                                  {...register(`items[${index}].debit`, {
                                    required: "Debit is required",
                                    validate: (value) =>
                                      (!isNaN(value) && value >= 0) ||
                                      "Debit must be a positive number",
                                  })}
                                />
                                {errors.items && errors.items[index]?.debit && (
                                  <span className="si-err">
                                    {errors.items[index].debit.message}
                                  </span>
                                )}
                              </td>
                              <td className="n" data-label="Credit">
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  className="si-cellin"
                                  {...register(`items[${index}].credit`, {
                                    required: "Credit is required",
                                    validate: (value) =>
                                      (!isNaN(value) && value >= 0) ||
                                      "Credit must be a positive number",
                                  })}
                                />
                                {errors.items && errors.items[index]?.credit && (
                                  <span className="si-err">
                                    {errors.items[index].credit.message}
                                  </span>
                                )}
                              </td>
                              <td data-label="Ref No.">
                                <input
                                  type="text"
                                  className="si-cellin si-cellin--text"
                                  placeholder="—"
                                  {...register(`items[${index}].refNo`)}
                                />
                                {errors.items && errors.items[index]?.refNo && (
                                  <span className="si-err">
                                    {errors.items[index].refNo.message}
                                  </span>
                                )}
                              </td>
                              <td data-label="Remarks">
                                <input
                                  type="text"
                                  className="si-cellin si-cellin--text"
                                  placeholder="—"
                                  {...register(`items[${index}].remarks`)}
                                />
                              </td>
                              <td>
                                <div className="si-rowacts">
                                  <Link
                                    to="#"
                                    className="si-rowbtn si-rowbtn--del confirm-text"
                                    title="Remove line"
                                    aria-label="Remove line"
                                    onClick={() => handleRemove(index)}
                                  >
                                    <Trash2 />
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {fields?.length === 0 && (
                      <div className="si-empty">
                        <p className="big">No lines yet</p>
                        <p>Press Add line to start the opening balance.</p>
                      </div>
                    )}
                  </div>

                  <div className="si-lines-foot">
                    <span>
                      Lines <b>{fields.length}</b>
                    </span>
                    <span>
                      Debit <b>{debitSum.toFixed(2)}</b>
                    </span>
                    <span>
                      Credit <b>{creditSum.toFixed(2)}</b>
                    </span>
                  </div>
                </section>

                {/* ============ STATUS BAR ============ */}
                <TermStatusBar
                  context={[
                    remarkShown,
                    docDate ? dayjs(docDate).format("DD-MM-YYYY") : null,
                  ]}
                />
              </div>

              {/* ============ RAIL ============ */}
              <aside className="si-rail">
                <div className="si-rail-scroll">
                  <div className="si-card">
                    <div className="si-card-h">
                      <span>Opening balance</span>
                      <span className="r">
                        {docDate ? dayjs(docDate).format("DD-MM-YYYY") : ""}
                      </span>
                    </div>
                    <div className="si-party">
                      <div className="nm">{remarkShown || "No remark"}</div>
                      <div className="meta">{`Entry ${watch("no") || "—"}`}</div>
                    </div>
                  </div>

                  <div className="si-card">
                    <div className="si-card-h">Summary</div>
                    <div className="si-tot">
                      <div className="si-tr">
                        <span className="l">Lines</span>
                        <span className="v">{fields.length}</span>
                      </div>
                      <div className="si-tr">
                        <span className="l">Total debit</span>
                        <span className="v">{debitSum.toFixed(2)}</span>
                      </div>
                      <div className="si-tr">
                        <span className="l">Total credit</span>
                        <span className="v">{creditSum.toFixed(2)}</span>
                      </div>
                    </div>
                    <div className="si-net">
                      <span className="l">
                        Net {netSum < 0 ? "(Cr)" : "(Dr)"}
                      </span>
                      <span className="v" title={Math.abs(netSum).toFixed(2)}>
                        {Math.abs(netSum).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>

                {!loading && (
                  <div className="si-actions">
                    <button className="si-btn si-btn--primary" type="submit">
                      <Check />
                      <span>Submit</span>
                    </button>
                    <button
                      type="button"
                      className="si-btn si-btn--ghost"
                      onClick={resetmodal}
                    >
                      <RotateCcw />
                      <span>Reset</span>
                    </button>
                  </div>
                )}
              </aside>
            </div>
          </form>
        </div>
      </div>
      {/* react-select menus portal here so they inherit the .si-term tokens */}
      <div ref={setMenuHost} className="si-menu-host" />
    </div>
  );
};
export default OpeningBalanceModal;
